<app-spinner-container [isLoading]="exportReportsBtnsComponent.isLoading" [diametre]="65">
    <mat-card appCard style="box-shadow: 0px 6px 22px -8px rgba(0, 0, 0, 0.2)">
        <mat-card-header class="titree">
            {{'Informations sur l acheteur public' | translate }}
        </mat-card-header>
        <mat-card-content class="card-content">

            <table class="table table-bordered">
                <tbody>
                <tr>
                    <th class="table-active" width="40%">{{'N° de réception'|translate}}</th>
                    <td>{{data_golb?.instRcvNo}}</td>
                </tr>
                <tr>
                    <th class="table-active">{{'Code acheteur public'|translate}}</th>
                    <td>{{data_golb?.instRegNo}} </td>
                    <!-- <td>{{data_golb?.instRegNo| date : 'dd/MM/yyyy - H:mm'}} </td> -->
                </tr>
                <tr>
                    <th class="table-active">{{'Nom de l acheteur public'|translate}}</th>

                    <td *ngIf="getlang()=='fr'"> {{data_golb?.instNmFr}}</td>
                    <td *ngIf="getlang()=='ar'">{{data_golb?.instNmAr}}</td>
                    <td *ngIf="getlang()=='en'">{{data_golb?.instNmEn}}</td>


                </tr>

                <tr>
                    <th class="table-active">{{'Abréviation du nom'|translate}}</th>

                    <td *ngIf="getlang()=='fr'"> {{data_golb?.instNmAbbrFr}}</td>
                    <td *ngIf="getlang()=='ar'">{{data_golb?.instNmAbbrAr}}</td>
                    <td *ngIf="getlang()=='en'">{{data_golb?.instNmAbbrEn}}</td>


                </tr>
                <tr>
                    <th class="table-active">{{'Type de l acheteur public'|translate}}</th>
                    <td *ngIf="getlang()=='fr'"> {{data_golb?.instClNmFr}}</td>
                    <td *ngIf="getlang()=='ar'">{{data_golb?.instClNmAr}}</td>
                    <td *ngIf="getlang()=='en'">{{data_golb?.instClNmEn}}</td>
                </tr>
                <tr>
                    <th class="table-active">{{'Division'|translate}}</th>
                    <td *ngIf="getlang()=='fr'"> {{data_golb?.areaClNmFr}}</td>
                    <td *ngIf="getlang()=='ar'">{{data_golb?.areaClNmAr}}</td>
                    <td *ngIf="getlang()=='en'">{{data_golb?.areaClNmEn}}</td>
                </tr>

                <tr>
                    <th class="table-active">{{'Matricule fiscal'|translate}}</th>
                    <td>{{data_golb?.taxId}}  </td>
                </tr>

                <tr>
                    <th class="table-active">{{'postal_code'|translate}}</th>
                    <td>{{data_golb?.postCd}}  </td>
                </tr>

                <tr>
                    <th class="table-active">{{'Adresse'|translate}}</th>
                    <td>{{data_golb?.addr1}} <br>
                        {{data_golb?.addr2}}
                    </td>
                </tr>

                <tr>
                    <th class="table-active">{{'site_web'|translate}}</th>
                    <td> {{data_golb?.hpage}}  </td>
                </tr>


                <tr>
                    <th class="table-active"> {{'nom_premier_resp'|translate}}    </th>
                    <td>{{data_golb?.chfNm}} </td>
                </tr>
                <tr>
                    <th class="table-active">{{'fonction_premier_resp'|translate}}</th>
                    <td>{{data_golb?.chfPosition}} </td>
                </tr>
                <tr>
                    <th class="table-active">{{'Email pour la notification du résultat'|translate}}</th>
                    <td>{{data_golb?.email}} </td>
                </tr>


                </tbody>
            </table>

        </mat-card-content>

    </mat-card>

    <br>
    <mat-card appCard style="box-shadow: 0px 6px 22px -8px rgba(0, 0, 0, 0.2)">
        <mat-card-header class="titree">
            {{'Informations sur le responsable' | translate }}
        </mat-card-header>
        <mat-card-content class="card-content">

            <table class="table table-bordered">
                <tbody>
                <tr>
                    <th class="table-active" width="40%">{{'Nom et prénom'|translate}}</th>
                    <td>{{data_golb?.staffNm}}</td>
                </tr>
                <tr>
                    <th class="table-active">{{'Identifiant unique du fonctionnaire'|translate}}</th>
                    <td>{{data_golb?.officialsId}} </td>
                </tr>
                <tr>
                    <th class="table-active">{{'Département'|translate}}</th>
                    <td>{{data_golb?.staffDeptNm}}</td>
                </tr>

                <tr>
                    <th class="table-active">{{'Fonction'|translate}}</th>
                    <td>{{data_golb?.positionNm}} </td>
                </tr>
                <tr>
                    <th class="table-active">{{'N° de téléphone fixe'|translate}}</th>
                    <td>{{data_golb?.telNo}}  </td>
                </tr>

                <tr>
                    <th class="table-active">{{'N° de fax'|translate}}</th>
                    <td>{{data_golb?.faxNo}}  </td>
                </tr>

                <tr>
                    <th class="table-active">{{'N° de tel portable'|translate}}</th>
                    <td>{{data_golb?.mtelNo}}  </td>
                </tr>


                </tbody>
            </table>

        </mat-card-content>

    </mat-card>


    <br>
    <mat-card appCard style="box-shadow: 0px 6px 22px -8px rgba(0, 0, 0, 0.2)">
        <mat-card-header class="titree">
            {{'Informations sur le traitement' | translate }}
        </mat-card-header>
        <mat-card-content class="card-content">

            <table class="table table-bordered">
                <tbody>
                <tr>
                    <th class="table-active" width="40%">{{'Date heure réception'|translate }}</th>
                    <td>{{data_golb?.rcvDt| dfth}} </td>

                </tr>
                <tr>
                    <th class="table-active">{{'Etat du déroulement'|translate}}</th>
                    <td *ngIf="getlang()=='fr'"> {{data_golb?.cdNmFr}}</td>
                    <td *ngIf="getlang()=='ar'">{{data_golb?.cdNmAr}}</td>
                    <td *ngIf="getlang()=='en'">{{data_golb?.cdNmEn}}</td>
                </tr>
                <tr>
                    <th class="table-active">{{'Motif du traitement'|translate}}</th>
                    <td>{{data_golb?.excReason}}</td>
                </tr>


                </tbody>
            </table>

        </mat-card-content>

    </mat-card>

    <div style="text-align: end;" class="mt-1">
        <app-export-reports-btns #exportReportsBtnsComponent [inputData]="{etat: 'reportRegistrationAch', fields: {instRcvNo: this.instRcvNo}}"></app-export-reports-btns>

        <button class="mx-1" *ngIf="data_golb?.cdNmFr!='Approuvé'" (click)="AnnulerDemandeAcheteur()" color="primary"
                mat-raised-button type="button">

            <span translate>Annuler la demande</span>

        </button>


        <button [routerLink]="['/portail/etat']"
                color="primary"
                type="button"
                mat-raised-button style="background-color:#3E90D0; color: white;"
                class="mx-1"
        >

            <span translate>Précédent</span>
        </button>
    </div>

</app-spinner-container>
